import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class PortInfoService {
  OBPortalSvcURL = '';
  asofdate: string | undefined;

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  // public getPortInfo(
  //   bookingCode: string | undefined,
  //   passedasofdate: string | undefined
  // ): Observable<any> {
  //   // this.asofdate = moment().format('YYYY-MM-DD HH:mm:ss');
  //   this.asofdate = passedasofdate;
  //   this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
  //   if (
  //     bookingCode == '16507041' ||
  //     bookingCode == '15938917' ||
  //     bookingCode == '16027656' ||
  //     bookingCode == '16771479' ||
  //     bookingCode == '16909161'
  //   ) {
  //     if (
  //       moment().isSameOrAfter(moment('2024-08-31T08:00')) &&
  //       moment().isSameOrBefore('2024-09-21T08:00')
  //     ) {
  //       bookingCode = '18776454';
  //     }
  //     if (
  //       moment().isSameOrAfter('2024-09-23T08:00') &&
  //       moment().isBefore('2024-09-30T08:00')
  //     ) {
  //       bookingCode = '18781972';
  //     }
  //     if (
  //       moment().isSameOrAfter('2024-09-30T08:01') &&
  //       moment().isBefore('2024-10-07T08:00')
  //     ) {
  //       bookingCode = '18781898';
  //     }
  //     if (
  //       moment().isSameOrAfter('2024-10-07T08:01') &&
  //       moment().isBefore('2024-10-14T08:00')
  //     ) {
  //       bookingCode = '18781919';
  //     }
  //   }
  //   const portInfo: JSON = <JSON>(<unknown>{
  //     bookingCode: bookingCode,
  //     asofdate: this.asofdate,
  //   });
  //   const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  //   return this.httpClient.post<any>(
  //     this.OBPortalSvcURL + 'GetPortInfo',
  //     JSON.stringify(portInfo),
  //     { headers: headers }
  //   );
  // }
  public getPortInfo(
    evtCode: string | undefined,
    passedasofdate: string | undefined
  ): Observable<any> {
    // this.asofdate = moment().format('YYYY-MM-DD HH:mm:ss');
    this.asofdate = passedasofdate;
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const portInfo: JSON = <JSON>(<unknown>{
      evtCode: evtCode,
      asofdate: this.asofdate,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetPortInfo',
      JSON.stringify(portInfo),
      { headers: headers }
    );
  }
}
